

export function AvenueLogo() {
  return (
    <img
      src="/images/78Avenue.png"
      style={{ width: 400, margin: '0 auto' }} />
  )
}